import { action, observable } from "mobx";
import { ObservableQuery } from "@apollo/client";
import { store } from "@store";
import {
  CustomerContractSubVersionListItemFragment,
  CustomerContractSubVersion_Delete,
  CustomerContractSubVersions_ByContractId,
  LegalPersonType
} from "@graphql";
import { FieldProps } from "@consultants/ConsultantContract/DynamicFieldsGroup";
import moment from "moment";

import { logSubscriptionError } from "@utils/log-subscription-error";
export type listItem = CustomerContractSubVersionListItemFragment["subVersions"][0];

export class SubVersionTableStore {
  @observable loading = false;
  @observable open = false;
  @observable missedFields: string[] = [];
  @observable canAddSubVersion = false;
  @observable list: listItem[] = null;
  @observable fields: FieldProps[] = [];
  @observable legalPersonType: LegalPersonType = null;
  @observable preFilledData: FormData = null;
  // @observable contractData: ConsultantInfo = null;

  get actualItems() {
    return this.list?.filter((x) =>
      moment(x.endDate).isAfter(moment().subtract(30, "days"))
    );
  }

  get pastItems() {
    return this.list?.filter((x) =>
      moment(x.endDate).isBefore(moment().subtract(30, "days"))
    );
  }

  query: ObservableQuery<
    CustomerContractSubVersions_ByContractId.Return,
    CustomerContractSubVersions_ByContractId.Variables
  >;

  constructor(id: string) {
    this.getList(id);

    (window as any).customerContractSnapshotTableStore = this;
  }

  subscribe = () => {
    this.query.subscribe({
      next: ({ data }) => {
        this.list = data.customerContractById?.subVersions;
        this.loading = false;
      },
      error: logSubscriptionError("SubVersionTableStore")
    });
  };

  @action getList = (customerContractId) => {
    this.loading = true;
    this.query = CustomerContractSubVersions_ByContractId.funcWatch({
      customerContractId
    });
    this.subscribe();
  };

  @action deleteFromList = (subVersionId) => {
    CustomerContractSubVersion_Delete.func(
      { subVersionId },
      { refetchQueries: [CustomerContractSubVersions_ByContractId.OperationName] }
    )
      .then(() => (this.list = this.list.filter((el) => el._id !== subVersionId)))
      .catch((e) => store().snackbars.error(`${e}`));
  };
}
